import {
    Box,
    Typography,
    IconButton,
    Button,
    Card,
    CardContent,
} from '@mui/material';
import { Add, DeleteOutline } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { ChipsInput } from '../ChipsInput';

type SetDefinition = Models.SetsPlayground.SetDefinition;
type SetFilterRequest = Models.SetsPlayground.SetFilterRequest;

type Props = {
    index?: number;
    set?: SetDefinition;
    filter?: SetFilterRequest;
    onChangeCategory: (index: number | undefined, categories: string[][]) => void;
};

const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
}));

export const CategoryFilterWidget = ({
    index,
    set,
    filter,
    onChangeCategory,
}: Props): JSX.Element => {
    const filterToUse = filter ?? set?.filters;
    const groups: string[][] = (filterToUse?.category as string[][]) ?? [];

    const handleGroupChange = (groupIdx: number, chips: string[]): void => {
        const next = groups.map((g, i) => (i === groupIdx ? chips : g));

        onChangeCategory(index, next);
    };

    const handleAddGroup = (): void => {
        const next = groups.length === 0 ? [[]] : [...groups, []];

        onChangeCategory(index, next);
    };

    const handleRemoveGroup = (groupIdx: number): void => {
        const next = groups.filter((_, i) => i !== groupIdx);

        onChangeCategory(index, next);
    };

    const hasGroups = groups.length > 0;

    return (
        <Box>
            <Typography gutterBottom fontWeight="medium" sx={{ mb: 3 }} variant="body2">
                Category Filters
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 2 }} variant="body2">
                Enter category keys (not names or IDs). Categories within the same group
                are OR&apos;d together. Different groups are AND&apos;d together.
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {!hasGroups && (
                <Typography color="text.secondary" variant="body2">
                    No category filter groups added yet.
                </Typography>
                )}
                {hasGroups
          && groups.map((group, idx) => {
              const key = `group-${idx}`;

              return (
                  <StyledCard key={key}>
                      <CardContent>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                              <Typography fontWeight="medium" sx={{ flex: 1 }} variant="body2">
                                  {`Group ${idx + 1}`}
                              </Typography>
                              <IconButton
                                  aria-label="remove group"
                                  color="error"
                                  onClick={(): void => handleRemoveGroup(idx)}
                              >
                                  <DeleteOutline fontSize="small" />
                              </IconButton>
                          </Box>
                          <ChipsInput
                              label="Category Keys"
                              values={group}
                              onChange={(next): void => handleGroupChange(idx, next)}
                          />
                      </CardContent>
                  </StyledCard>
              );
          })}
                <Box display="flex" justifyContent="flex-end">
                    <Button startIcon={<Add />} variant="outlined" onClick={handleAddGroup}>
                        Add Group
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};
